import useSEO from '../hooks/useSEO';

const SEO = ({ 
  title = 'Sea What You Save - Aquarium Fish Price Comparison', 
  description = 'Compare aquarium fish prices across multiple stores. Find the best deals on saltwater and freshwater fish, coral, and aquarium supplies.',
  keywords = 'aquarium fish prices, fish price comparison, saltwater fish, freshwater fish, coral prices, aquarium supplies',
  canonical,
  path
}) => {
  useSEO({
    title,
    description,
    keywords,
    canonical: canonical || path
  });

  return null; // This component doesn't render anything
};

export default SEO;
